import type { FC, PropsWithChildren } from "react";

import startCase from "lodash/startCase";
import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { FlexRowFlexEnd } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const NewLostCellWrapper = styled(FlexRowFlexEnd)`
    gap: 10px;
`;

const NewLostChipWrapper = styled.div<{ isNew: boolean }>`
    color: ${({ isNew }) => (isNew ? colorsPalettes.green["s100"] : colorsPalettes.red["s100"])};
`;

interface INewLostCellProps {
    isNew: boolean;
}

/**
 * @deprecated Use StateChangeCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/views/state-change-cell/StateChangeCell.tsx}
 */

export const NewLostCell: FC<PropsWithChildren<INewLostCellProps>> = ({ isNew, children }) => {
    const label = translate(`common.tooltip.change.${isNew ? "new" : "lost"}`);
    const newLostChip = <NewLostChipWrapper isNew={isNew}>{startCase(label.toLowerCase())}</NewLostChipWrapper>;

    return (
        <Box>
            {newLostChip}
            {children}
        </Box>
    );
};
